import React from 'react';
import proptypes from 'prop-types';

const { arrayOf, shape, string } = proptypes;

export const TableView = ({ title, information }) => {
  const {
    whatInformationDoesThisInclude,
    whereDoWeCollectItFrom,
    whyDoWeCollectIt,
    whoDoWeShareItWith
  } = information;

  return (
    <div className="sui-grid">
      <div className="box-shadow">
        <h4><b>{title}</b></h4>
        <div className="sui-grid sui-gap-4 md:sui-grid-cols-12">
          <div className="md:sui-col-span-3">
            <h5><b>What Information Does This Include?</b></h5>
            <div className="content-margin-10" />
            {/* eslint-disable-next-line react/no-danger */}
            <p dangerouslySetInnerHTML={{ __html: whatInformationDoesThisInclude }} />
          </div>
          <div className="md:sui-col-span-3">
            <h5><b>Where Do We Collect It From?</b></h5>
            <div className="content-margin-10" />
            <ul>
              {whereDoWeCollectItFrom.map((msg, index) => {
                // eslint-disable-next-line react/no-danger
                return <li key={`collect-${index}`} dangerouslySetInnerHTML={{ __html: msg }} />;
              })}
            </ul>
          </div>
          <div className="md:sui-col-span-3">
            <h5><b>Why Do We Collect and Disclose It?</b></h5>
            <div className="content-margin-10" />
            <ul>
              {whyDoWeCollectIt.map((msg, index) => {
                // eslint-disable-next-line react/no-danger
                return <li key={`why-${index}`} dangerouslySetInnerHTML={{ __html: msg }} />;
              })}
            </ul>
          </div>
          <div className="md:sui-col-span-3">
            <h5><b>Who Do We Disclose It To?</b></h5>
            <div className="content-margin-10" />
            <ul>
              {whoDoWeShareItWith.map((msg, index) => {
                // eslint-disable-next-line react/no-danger
                return <li key={`share-${index}`} dangerouslySetInnerHTML={{ __html: msg }} />;
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="content-margin-30" />
    </div>
  );
};

TableView.propTypes = {
  title: string.isRequired,
  information: shape({
    whatInformationDoesThisInclude: string.isRequired,
    whereDoWeCollectItFrom: arrayOf(string).isRequired,
    whyDoWeCollectIt: arrayOf(string).isRequired,
    whoDoWeShareItWith: arrayOf(string).isRequired
  }).isRequired
};
